import React from 'react'
import styled from 'styled-components'
import { graphql } from 'gatsby'

import PageHead from '../../components/page-head'
import Layout from '../../components/layout'
import SEO from '../../components/seo'
import Message from '../../components/message'
import Card from '../../components/overlapCard'
import Btn from '../../components/button'
import { colors, CardWrap, md } from '../../common'

const StoriesPage = ( props ) => {
  const markdown = props.data.allMarkdownRemark.edges
  const stories = markdown.filter(e => e.node.frontmatter.story)
  console.table(stories)
  return (
    <Layout>
      <SEO title="Stories" />
      <PageHead
      image={'https://s3.us-east-2.amazonaws.com/kings-jewelers/medis/stories-option01.jpg'}
      title={'Joyful Moments'}
      subtitle={"We didn’t realize we were making memories; we just knew we were having fun."}/>
      <Message
      message={`<p>Jewelry is made of gems, precious metals, and stories. The story can tell how the jewelry was made or the story of why the jewelry was chosen - to celebrate true love, or mark a milestone birthday or anniversary, or simply to put a smile on someone special's face. We share our favorite jewelry stories here.</p>`}
      css={''}/>
      <CardWrap>
        {stories.map((item, index) => {
          const story = item.node.frontmatter
          return <ECard
                key={index}
                image={story.image}
                cardCss={'margin:10px;max-width:400px;min-width:30%;'}
                mcss={'margin:auto;'}
                textColor={colors.brownDark}>
                  <div>
                    <h2>{story.story}</h2>
                    <p>{story.short}</p>
                    <Btn link={story.path} text={'details'} style={{width: "80%"}}/>
                  </div>
                </ECard>
        })}
      </CardWrap>
    </Layout>
  )
}

export default StoriesPage

export const storyQuery = graphql`
  query StoryQuery {
  	allMarkdownRemark {
  	  edges {
  	    node {
  	      id
          frontmatter {
            story
            path
            image
            short
          }
  	    }
  	  }
  	}
  }
`

const ECard = styled(Card)`
  width: 20%
  margin: 10px;

  ${md} {
    width: 100%;
    margin: 0;
  }
`
